import { mapEnumToOptions } from '@abp/ng.core';

export enum RegionEnum {
  Turkey = 1,
  Paris = 2,
  London = 4,
  Dubai = 8,
  Ohio = 16,
  Jeddah = 32,
}

export const RegionEnumOptions = mapEnumToOptions(RegionEnum);
